/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AiProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Generate text based on a given prompt
   * @param requestBody
   * @returns any status success
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesAiCompletion(
    requestBody?: {
      prompt: string;
    },
  ): CancelablePromise<{
    data?: {
      /**
       * the generated text from the AI generation service
       */
      text: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/ai/completion',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Generate a company branding based on a given prompt
   * @param requestBody
   * @returns any status success
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesAiBranding(
    requestBody?: {
      websiteUrl: string;
    },
  ): CancelablePromise<{
    data?: {
      logoUrl?: string;
      colors?: {
        primary?: string;
        secondary?: string;
      };
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/ai/branding',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Search for brands using Brandfetch API
   * @param query Company name or website to search for
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesAiBrandfetchSearch(
    query: string,
  ): CancelablePromise<{
    data?: Array<{
      /**
       * Company domain/website URL
       */
      url: string;
      /**
       * Company name
       */
      name: string;
      /**
       * Public URL to the logo image
       */
      logoUrl: string;
    }>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/ai/brandfetch-search',
      query: {
        'query': query,
      },
      errors: {
        400: `default error response`,
        503: `default error response`,
      },
    });
  }

}
